export default __webpack_public_path__ + "static/media/frame.f2f51dff.svg";